/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { tryDefine } from '@tylertech/forge-core';
import { MeterComponent } from './meter';
export * from './meter';
export function defineMeterComponent() {
    tryDefine('forge-meter', MeterComponent);
}
